import Clarity from '@microsoft/clarity';

const PROD_HOSTNAME = 'cashback.scn.roxcode.io';
const PROD_CLARITY_PROJECT_ID = 'ujuvl4yj30';
const NON_PROD_CLARITY_PROJECT_ID = 'w8kfuybk5c';

let clarityInitialized = false;

const getClarityProjectId = () =>
  window.location.hostname === PROD_HOSTNAME
    ? PROD_CLARITY_PROJECT_ID
    : NON_PROD_CLARITY_PROJECT_ID;

const isClarityEnabled = () => typeof window !== 'undefined' && Boolean(getClarityProjectId());

export const initClarity = () => {
  if (clarityInitialized || !isClarityEnabled()) return;

  Clarity.init(getClarityProjectId());
  clarityInitialized = true;
};

export const setClarityPageTag = (pageName?: string) => {
  if (!isClarityEnabled() || !pageName) return;

  initClarity();
  Clarity.setTag('page_name', pageName);
};

export const identifyClarityUser = (
  userIdentifier?: string,
  userTier?: string,
  userName?: string,
  pageId?: string
) => {
  if (!isClarityEnabled() || !userIdentifier) return;

  initClarity();

  Clarity.identify(userIdentifier, undefined, pageId, userName);

  // Prioritize identified sessions when Clarity is sampling recordings.
  Clarity.upgrade('identified_session');

  if (userTier) {
    Clarity.setTag('user_tier', userTier);
  }

  Clarity.setTag('user_compassCode', userIdentifier);

  if (userName) {
    Clarity.setTag('user_name', userName);
  }
};
